var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C3.36433 15 0 11.6357 0 7.5C0 3.36433 3.36433 0 7.5 0C11.6357 0 15 3.36433 15 7.5C15 11.6357 11.6357 15 7.5 15ZM7.5 0.9375C3.88126 0.9375 0.9375 3.88126 0.9375 7.5C0.9375 11.1187 3.88126 14.0625 7.5 14.0625C11.1187 14.0625 14.0625 11.1187 14.0625 7.5C14.0625 3.88126 11.1187 0.9375 7.5 0.9375Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 7.96875H4.21875C3.96 7.96875 3.75 7.75875 3.75 7.5C3.75 7.24125 3.96 7.03125 4.21875 7.03125H10.7812C11.04 7.03125 11.25 7.24125 11.25 7.5C11.25 7.75875 11.04 7.96875 10.7812 7.96875Z",
    fill: "#535353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25C7.24125 11.25 7.03125 11.04 7.03125 10.7812V4.21875C7.03125 3.96 7.24125 3.75 7.5 3.75C7.75875 3.75 7.96875 3.96 7.96875 4.21875V10.7812C7.96875 11.04 7.75875 11.25 7.5 11.25Z",
    fill: "#535353"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.684a7315.svg";
export { ForwardRef as ReactComponent };